// Libraries
import { TypeOf, z } from 'zod';
// Translations
import text from '@translations/en.json';

/**
 * Zod schema for the login form data.
 */
export const LoginSchema = z.object({
  /**
   * The username or email address input field.
   */
  username: z.string({
    required_error: text.username_error_message,
  }),
  /**
   * The password input field.
   */
  password: z.string({
    required_error: text.password_error_message,
  }),
});

/**
 * Represents the type of values accepted by the loginSchema.
 */
export type LoginValues = TypeOf<typeof LoginSchema>;
